export default __webpack_public_path__ + "static/media/congo_carte_1-min.bb8ab066.png";